"use strict";

import React from "react";
import Head from "next/head";
import { I18nextProvider } from "react-i18next";
import { startI18n, getTranslation } from "../src/helpers/i18n";
import MyHead from "../src/components/MyHead";
import LoginForm from "../src/components/LoginForm";
import SignUpForm from "../src/components/SignUpForm";
import detectIE from "../src/helpers/detectIE";
import Footer from "../src/components/Footer";
import UnsupportedBrowser from "./unsupportedBrowser";
import withAuthentication from "./../src/HOC/withAuthentication";
import SwitchLang from "./../src/components/SwitchLang";

class Login extends React.Component {
  static async getInitialProps({ req = {} }) {
    const { locale = process.env.DEFAULT_LANG } = req;
    const translations = await getTranslation(locale);

    return { locale, translations };
  }

  constructor(props) {
    super(props);
    this.i18n = startI18n(props.translations, props.locale);
    this.state = {
      isIE: false,
    };
  }

  componentDidMount() {
    this.setState({ isIE: detectIE() });
  }

  render() {
    if (this.state.isIE) {
      return <UnsupportedBrowser {...this.props} />;
    }
    const { locale } = this.props;

    const title = this.i18n.t("HEAD_LOGIN_TITLE");

    return (
      <I18nextProvider i18n={this.i18n}>
        <div>
          <MyHead locale={locale} />
          <Head>
            <title>{title}</title>
          </Head>

          <section className="cont-100vh bg-gradient">
            <div className="switch-lang">
              <p>
                <SwitchLang route="login" />
              </p>
            </div>
            <div className="container login-page">
              <img
                src="/static/image/Icona+Naming_NeerU.svg"
                className="img-fluid u-center-horizontal"
                alt={title}
              />

              <div className="cont-login">
                <div className="row">
                  <LoginForm locale={this.props.locale} />
                  <SignUpForm locale={this.props.locale} />
                </div>
              </div>
            </div>
            <Footer noSticky />
          </section>
        </div>
      </I18nextProvider>
    );
  }
}

export default withAuthentication(Login);



// WEBPACK FOOTER //
// pages/login.js